// ccp/src/hooks/useAcwClock.js
//
// D32 (2026-09-14): a running clock from the moment after-call work begins,
// visible immediately and counting up every second, urgent at the shared
// threshold. Storm's ruling: the counter is never hidden before the
// threshold — the agent always sees that time in ACW is being measured.
import { useEffect, useState } from 'react';
import { acwElapsedSeconds, isAcwUrgent, fmtClock } from '../lib/acw';

export function useAcwClock(startedAt) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!startedAt) return undefined;
    setNow(Date.now());
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [startedAt]);
  const seconds = acwElapsedSeconds(startedAt, now);
  return { seconds, text: fmtClock(seconds), urgent: isAcwUrgent(startedAt, now) };
}
